import { useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';

//Primereact components
import { Toast } from 'primereact/toast';
import { Button } from 'primereact/button';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { RadioButton } from 'primereact/radiobutton';
import { InputText } from 'primereact/inputtext';
import { InputTextarea } from 'primereact/inputtextarea';

import { CertificatesTab } from '../CertificatesTab';
import { CertificateShowClick, SaveGoodStandingCertificateValidate } from '../../../config/Validate';
import { formatDate } from '../../../appconfig/AppHelper';
import { getAllDetails, getAllDetailsDirect, postAllData } from '../../../service/ProductService';
import { DOWNLOAD_GOODSTANDING_CERTIFICATE, GET_GOODSTANDING_CERTIFICATE } from '../../../config/ApiConstant';
import { CANADATOADDRESS, defaultPageRowOptions, defaultRowOptions, SkeletonbodyTemplate, Skeletonitems, UKTOADDRESS, USTOADDRESS } from '../../../appconfig/Settings';
import { GoodStandingCertListShowColumns } from '../../../appconfig/DatatableSetting';
import Loader from '../../../components/Loadeer/Loader';
import { Editor } from 'primereact/editor';
export const GoodStandingCertificate = () => {
    document.title = 'GoodStanding Certificate | GSPC';

    //Set Toast/ Filter Properties
    const toast = useRef<any>(null);
    const [globalFieldFilter, setGlobalFieldFilter] = useState<any>(null);
    const [globalFilter, setGlobalFilter] = useState<any>(null);

    const navigate = useNavigate();

    //Loading/Page Loading
    const [pageLoad, setPageLoad] = useState<boolean>(true);
    const [downloadLoader, setDownloadLoader] = useState<boolean>(false);
    const [certificateList, setCertificateList] = useState<any>([]);
    const [regNo, setRegNo] = useState<any>(null);
    const [certificateData, setCertificateData] = useState<any>({});
    const [country, setCountry] = useState<any>(null);
    const [paraBox, setParaBox] = useState<any>('');
    const [showLoading, setShowLoading] = useState<boolean>(false);
    const [saveLoader, setSaveLoader] = useState<boolean>(false);
    const [errors, setErrors] = useState<any>({});

    // Clear all
    const clearAll = () => {
        setRegNo(null);
        setCertificateData({});
        setCertificateList([]);
        setCountry(null);
        setParaBox('');
        setErrors({});
    };

    // On show click
    const onShowClick = async () => {
        try {
            const { errors, isError } = CertificateShowClick(regNo);
            setErrors(errors);

            //Check Error if no errors then call API
            if (!isError) {
                setShowLoading(true);
                setPageLoad(false);

                const response = await getAllDetailsDirect(GET_GOODSTANDING_CERTIFICATE + '?RegNo=' + regNo);
                if (window.cn(response.details)) {
                    setShowLoading(false);
                    setPageLoad(false);
                    toast.current?.show({ severity: 'error', summary: 'Message', detail: 'Registration Number Is Wrong!' });
                } else {
                    if (!window.cn(response.details) && !window.cn(response.details[0])) {
                        setShowLoading(false);
                        setPageLoad(true);
                        setCertificateData(response.details[0]);
                        if (response?.list) {
                            setCertificateList(response.list);
                        }
                    } else {
                        setShowLoading(false);
                        setPageLoad(false);
                        clearAll();
                        toast.current?.show({ severity: 'error', summary: 'Message', detail: 'User is not connected with G Number so first create an account and after that Provisional Certificate will be issued.' });
                    }
                }
            }
        } catch (error: any) {
            if (error.response) {
                //Spinner False and Set Toast

                setShowLoading(false);
                toast.current?.show({ severity: 'error', summary: 'Error', detail: 'Could Not Load Data' });
            }
        }
    };

    //onchange event
    const onInputChange = (e: any, name: string) => {
        let val;
        if (name === 'country') {
            let paraBoxTxt = certificateDescription(e);
            setCountry(e);
            name = 'toAddress';
            if (e === 'USA') {
                val = USTOADDRESS;
            } else if (e === 'CANADA') {
                val = CANADATOADDRESS;
            } else {
                val = UKTOADDRESS;
            }
            setParaBox(paraBoxTxt);
        } else {
            val = (e.target && e.target.value) || e.value || '';
        }
        setCertificateData({ ...certificateData, [name]: val });
    };

    // Set certificate description
    const certificateDescription = (country: any) => {
        // Condition Checks for the Data
        let name = !window.cn(certificateData.NameChange) ? certificateData.Name + ' Alias ' + certificateData.NameChange : certificateData.Name;
        let gender = certificateData.Gender == 'Male' ? 'He' : 'She';
        let genderRelating = certificateData.Gender == 'Male' ? 'his' : 'her';

        let paraBoxText = '';
        if (country === 'USA') {
            // USA Data
            paraBoxText =
                '&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; With reference to the subject cited above, please find enclosed a duly certified copy of the registration certificate for ' +
                '<b> "' +
                name +
                '"</b> bearing Registration No. ' +
                '<b>"' +
                certificateData.RegNo +
                '"</b>' +
                ', as requested' +
                // genderRelating +
                '.<br/><br/>' +
                '&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; ' +
                name +
                ' is registered with the Gujarat State Pharmacy Council under the Pharmacy Act, 1948  with effect from ' +
                formatDate(certificateData.RegDt) +
                ' based on ' + genderRelating +  ' successful completion of the Bachelor of Pharmacy (4-year program). ' +  genderRelating + ' registration is valid from ' +
                formatDate(certificateData.RegDt) +
                ' to ' +
                formatDate(certificateData.LastVDate) +
                '.<br/><br/>' +
                '&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Please note that ' +
                name +
                ' has surrendered ' + genderRelating + ' original registration certificate to the Council, as per the statutory provisions of the Indian Pharmacy Act, 1948.' +
                '<br/>' +
                '&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; ' +
                'Thank you for your attention to this matter.';
        } else if (country === 'CANADA') {
            // Canada Data
            paraBoxText =
                '&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; This is to certify that ' +
                '<b>"' +
                name +
                '"</b>' +
                ' is a Registered Pharmacist of this Council.<br/><br/>' +
                '&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; ' +
                gender +
                ' has applied for a Good Standing Certificate form council, with a purpose to submit the same to the Examination Authority in Canada which is conducting and Evaluating Exam in Canada. </br></br>' +
                '&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; ' +
                gender +
                ' is  registered  under  the  Pharmacy Act, 1948 with the Gujarat State Pharmacy Council under registration No. ' +
                '<b>' +
                certificateData.RegNo +
                '</b> dated  ' +
                formatDate(certificateData.RegDt) +
                ' based on a <b>Bachelor of  Pharmacy (4 years course)</b> from Gujarat Technological University, Gujarat. The registration is valid from ' +
                formatDate(certificateData.RegDt) +
                ' To ' +
                formatDate(certificateData.LastVDate) +
                '.<br/><br/>' +
                "&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Accroading to the knowledge and belief of the Gujarat State Pharmacy Council, there is no adverse event reported against him in the Council. " +
                genderRelating +
                '.';
        } else {
            // UK Data
            paraBoxText =
                '&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; This is to certify that ' +
                '<b>"' +
                name +
                '"</b>' +
                ' is a registered pharmacist under the Gujarat State Pharmacy Council, ' +
                '"<b>  bearing Registration No. ' +
                certificateData.RegNo +
                '</b>", registered  on ' +
                formatDate(certificateData.RegDt) +
                '.' +
                ' ' +
                genderRelating +
                ' registration is valid until ' +
                formatDate(certificateData.LastVDate) +
                ', in accordance with the Pharmacy Act, 1948. </br></br>' + '&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;' +
                name + 
                ' has applied for a Certificate of Good Standing with the purpose of submitting it to the Examination Authority for the Overseas Pharmacists Assessment Programme (OSPAP) and Society Registration Examination, conducted by the General Pharmaceutical Council (GPhC), London, UK.</br></br>' +
                '&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; ' +
                'As per the records of the Gujarat State Pharmacy Council, there are no complaints, disciplinary actions, or adverse reports against' +
                genderRelating +
                ' registration.</br></br>' +
                '&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; The following are her details as per our official records:</br> ' +
                '<ol><li>' +
                '<b>' +
                'Name: ' +
                '</b>' +
                name +
                '</li>' +
                '<li>' +
                '<b>' +
                'Date of Birth: ' +
                '</b>' +
                formatDate(certificateData.BOD) +
                '</li>' +
                 '<li>' +
                '<b>' +
                'Pharmacy Qualification: ' +
                '</b>' + 'Bachelor of Pharmacy (' + 
               certificateData.ColName + ')' +
                '</li>' +
                '<li>' +
                '<b>' +
                'Registered Address: ' +
                '</b>' +
                certificateData.PAddress +
                '</li></ol> '  +
                '&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; This certificate is issued upon ' + genderRelating + ' request and for the purpose stated above.</br> ' ;
        }

        return paraBoxText;
    };

    // Save Good Standing Certificate
    const saveGoodCertificate = async () => {
        try {
            const { errors, isError } = SaveGoodStandingCertificateValidate(certificateData);
            setErrors(errors);

            //Check Error if no errors then call API
            if (!isError) {
                setSaveLoader(true);

                let requestData: any = {};

                // Changing Country Status Code
                let USA = 0;
                let CANADA = 0;
                let GBritan = 0;

                if (country === 'USA') {
                    USA = 1;
                } else if (country === 'CANADA') {
                    CANADA = 1;
                } else {
                    GBritan = 1;
                }

                let fdAddress = certificateData.fdaddress.toUpperCase();

                // Request Data
                requestData = {
                    ...certificateData,
                    USA,
                    CANADA,
                    GBritan,
                    para_box: paraBox,
                    ToAddress: certificateData.toAddress,
                    CertI: 1,
                    fdaddress: fdAddress
                };

                // Some Unneccesary fields is removed
                delete requestData['BOD'];
                delete requestData['DegNm'];
                delete requestData['EntDt'];
                delete requestData['PAddress'];
                delete requestData['NameChange'];
                delete requestData['RegDt'];
                delete requestData['LastVDate'];
                delete requestData['Gender'];
                delete requestData['toAddress'];
                 delete requestData['ColName'];

                const response = await postAllData(GET_GOODSTANDING_CERTIFICATE, requestData);
                if (response) {
                    setSaveLoader(false);
                    onShowClick();
                    toast.current?.show({ severity: 'success', summary: 'Message', detail: response?.data });
                }
            }
        } catch (error: any) {
            if (error.response) {
                //Spinner False and Set Toast
                setSaveLoader(false);
                toast.current?.show({ severity: 'error', summary: 'Error', detail: 'Something Went Wrong' });
            }
        }
    };

    // Template for issue date
    const IssueDateTemplate = (rowData: any, rowIndex: any) => {
        return <>{!window.cn(rowData.CertIDt) ? formatDate(rowData.CertIDt) : ''}</>;
    };

    // Template for country
    const countryTemplate = (rowData: any, rowIndex: any) => {
        return <>{rowData?.USA === 1 ? 'USA' : rowData?.Canada === 1 ? 'CANADA' : 'GREAT BRITAIN'}</>;
    };

    // Template for actions
    const actionsTemplate = (rowData: any, rowIndex: any) => {
        return (
            <>
                <div className="actions action-btn">
                    <Button icon="pi pi-download" tooltip="Download" tooltipOptions={{ position: 'top' }} className="p-button-primary" onClick={() => downloadCertificate(rowData.SrNo)} />
                </div>
            </>
        );
    };

    // Download certificate
    const downloadCertificate = async (SrNo: any) => {
        try {
            setDownloadLoader(true);
            const response = await getAllDetails(DOWNLOAD_GOODSTANDING_CERTIFICATE + '?sr_no=' + SrNo);
            if (response) {
                //PDF Download
                const fileName = `Good-Standing-Certificate-${new Date().getTime()}.pdf`;
                const link = document.createElement('a');
                link.href = response;
                link.target = '_blank';
                link.download = fileName;
                document.body.appendChild(link);
                link.click();
                setDownloadLoader(false);
            } else {
                setDownloadLoader(false);

                toast.current?.show({ severity: 'error', summary: 'Error', detail: 'Something Went Wrong' });
            }
        } catch (error: any) {
            if (error.response) {
                //Spinner False and Set Toast
                setDownloadLoader(false);

                toast.current?.show({ severity: 'error', summary: 'Error', detail: 'Something Went Wrong' });
            }
        }
    };

    return (
        <>
            <CertificatesTab mainTabLabel="Good Standing Certificate" />
            <Toast ref={toast} />
            <div className="grid crud-demo mt-2">
                <div className="col-12">
                    <div className="card">
                        <div className="p-fluid formgrid grid align-items-center">
                            <div className="field col-12 md:col-4">
                                <label htmlFor="regNo">
                                    Reg No <span style={{ color: 'red' }}>*</span>
                                </label>
                                <InputText value={!window.cn(regNo) ? regNo : ''} name="regNo" autoComplete="off" placeholder="Enter Reg No." onChange={(e) => setRegNo(e.target.value)} className={errors['regNo'] && 'p-invalid'} />
                                <small className="p-invalid-txt">{errors['regNo']}</small>
                            </div>
                            <div className="field col-12 md:col-1 mt-4">
                                <Button label="Show" className="p-button-primary" onClick={() => onShowClick()} loading={showLoading} />
                            </div>
                            <div className="field col-12 md:col-4"></div>
                            <div className="field col-12 md:col-3 mb-0">
                                <Button label="GoodStanding Certificate List" className="p-button-primary p-button-outlined" onClick={() => navigate('/app/certificate/goodstanding-certificate-list')} />
                            </div>
                        </div>
                        <hr />
                        <div className="p-fluid formgrid grid">
                            <div className="field col-12 md:col-4">
                                <label htmlFor="Name">Student Name</label>
                                <InputText value={!window.cn(certificateData?.Name) ? certificateData?.Name : ''} name="Name" disabled={true} />
                            </div>
                            <div className="field col-12 md:col-4">
                                <label htmlFor="DegNm">Degree</label>
                                <InputText value={!window.cn(certificateData?.DegNm) ? certificateData?.DegNm : ''} name="DegNm" disabled={true} />
                            </div>
                            <div className="field col-12 md:col-4">
                                <label htmlFor="BOD">Birth Date</label>
                                <InputText value={!window.cn(certificateData?.BOD) ? certificateData?.BOD : ''} name="BOD" disabled={true} />
                            </div>
                            <div className="field col-12 md:col-4">
                                <label htmlFor="PAddress">Permanent Address</label>
                                <InputTextarea rows={5} cols={30} value={!window.cn(certificateData?.PAddress) ? certificateData?.PAddress : ''} name="PAddress" disabled={true} />
                            </div>
                            <div className="field col-12 md:col-4">
                                <label htmlFor="toAddress">To Address</label>
                                <InputTextarea rows={5} cols={30} value={!window.cn(certificateData?.toAddress) ? certificateData?.toAddress : ''} name="toAddress" onChange={(e) => onInputChange(e, 'toAddress')} />
                                <small className="p-invalid-txt">{errors['toAddress']}</small>
                                <small>Note: Use ( , ) for the Address separation</small>
                            </div>
                            <div className="field col-12 md:col-4">
                                <label htmlFor="fdaddress">F&D Address</label>
                                <InputTextarea rows={5} cols={30} value={!window.cn(certificateData?.fdaddress) ? certificateData?.fdaddress : ''} name="fdaddress" onChange={(e) => onInputChange(e, 'fdaddress')} />
                                <small className="p-invalid-txt">{errors['fdaddress']}</small>
                                <small>Note: Use ( , ) for the Address separation</small>
                            </div>
                            <div className="field col-12 md:col-4">
                                <label htmlFor="RegDt">Reg Date</label>
                                <InputText value={!window.cn(certificateData?.RegDt) ? formatDate(certificateData?.RegDt) : ''} name="RegDt" disabled={true} />
                            </div>
                            <div className="field col-12 md:col-6">
                                <label htmlFor="country" className="mb-3">
                                    Country
                                </label>
                                <div className="grid">
                                    <div className="col-12 md:col-4 lg:col-4">
                                        <div className="field-radiobutton">
                                            <RadioButton inputId="option1" name="option" value="USA" checked={country === 'USA'} onChange={(e) => onInputChange(e.value, 'country')} />
                                            <label htmlFor="option1">USA</label>
                                        </div>
                                    </div>
                                    <div className="col-12 md:col-4 lg:col-4">
                                        <div className="field-radiobutton">
                                            <RadioButton inputId="option2" name="option" value="CANADA" checked={country === 'CANADA'} onChange={(e) => onInputChange(e.value, 'country')} />
                                            <label htmlFor="option2">CANADA</label>
                                        </div>
                                    </div>
                                    <div className="col-12 md:col-4 lg:col-4">
                                        <div className="field-radiobutton">
                                            <RadioButton inputId="option2" name="option" value="GREAT BRITIAN" checked={country === 'GREAT BRITIAN'} onChange={(e) => onInputChange(e.value, 'country')} />
                                            <label htmlFor="option2">GREAT BRITIAN</label>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="field col-12 md:col-12 lg:col-12">
                                <Editor value={paraBox} onTextChange={(e) => setParaBox(e.htmlValue)} style={{ height: '320px' }} />
                            </div>
                        </div>
                        <div className="formgrid grid">
                            <div className="field col-12 md:col-12">
                                <div style={{ display: 'flex', float: 'right', gap: 4 }}>
                                    <Button label="Clear" className="p-button-secondary" icon="pi pi-times" onClick={() => clearAll()} />
                                    <Button label="Save" onClick={() => saveGoodCertificate()} icon="pi pi-check" loading={saveLoader} disabled={!window.cn(certificateData) && !window.cn(country) ? false : true} />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="card">
                        {/* Datatable */}
                        {pageLoad ? (
                            <>
                                <DataTable
                                    value={certificateList}
                                    showGridlines
                                    stripedRows
                                    globalFilter={globalFilter}
                                    filters={globalFieldFilter}
                                    onFilter={(e) => setGlobalFieldFilter(e.filters)}
                                    rows={defaultRowOptions}
                                    paginator={certificateList.length >= 10 && true}
                                    rowsPerPageOptions={defaultPageRowOptions}
                                    className="datatable-responsive p-datatable-sm"
                                    emptyMessage="No Certificates Found"
                                >
                                    {GoodStandingCertListShowColumns.map((col, i) => {
                                        if (col.field === 'action') {
                                            return <Column key={col.field} field={col.field} header={col.header} body={actionsTemplate} />;
                                        } else if (col.field === 'country') {
                                            return <Column key={col.field} field={col.field} header={col.header} body={countryTemplate} />;
                                        } else if (col.field === 'CertIDt') {
                                            return <Column key={col.field} field={col.field} header={col.header} body={IssueDateTemplate} />;
                                        } else {
                                            return <Column key={col.field} field={col.field} header={col.header} sortable filter filterPlaceholder={'Search by ' + col.header} />;
                                        }
                                    })}
                                </DataTable>
                            </>
                        ) : (
                            <>
                                {/* Skeleton Data table */}
                                <DataTable value={Skeletonitems}>
                                    {GoodStandingCertListShowColumns.map((col, i) => (
                                        <Column key={col.field} field={col.field} header={col.header} body={SkeletonbodyTemplate} />
                                    ))}
                                </DataTable>
                            </>
                        )}
                    </div>
                </div>
            </div>

            {downloadLoader && <Loader />}
        </>
    );
};
